// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.line-setting-style[data-v-5834170d] {\n  width: 280px;\n}\n", ""]);
// Exports
module.exports = exports;
